import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVectorAnchorPointStraight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVectorAnchorPointStraight"><Path d="M12 4C14.0711 4 15.75 5.67893 15.75 7.75C15.75 8.58297 15.478 9.35222 15.0186 9.97461L22.3105 17.5176L21.2324 18.5605L13.9043 10.9795C13.346 11.3094 12.6955 11.5 12 11.5C11.3175 11.5 10.6782 11.3166 10.127 10.998L2.76367 18.5605L1.68945 17.5137L9.00195 10.0029C8.52985 9.37568 8.25 8.59553 8.25 7.75C8.25 5.67893 9.92893 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVectorAnchorPointStraight;
